import Vue from 'vue'
import Router from 'vue-router'
import AppContainer from './views/appcontainer/AppContainer.vue'
import EditorContainer from './views/appcontainer/components/EditorContainer.vue'
import AddNewApp from './views/addnewapp/AddNewApp.vue'
import Home from './views/home/Home.vue'

Vue.use(Router)

const APP_TITLE = 'Beurer Legal Front End' // default title for our SPA
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [{
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      title: 'Home - ' + APP_TITLE,
      metaTags: [{
        name: 'description',
        content: 'The home page of ' + APP_TITLE
      },
      {
        property: 'og:description',
        content: 'The home page of ' + APP_TITLE
      }
      ]
    }
  },
  {
    path: '/addnewapp',
    name: 'addnewapp',
    component: AddNewApp,
    meta: {
      title: 'Add New App - ' + APP_TITLE,
      metaTags: [{
        name: 'description',
        content: 'Add New App'
      },
      {
        property: 'og:description',
        content: 'Add New App'
      }
      ]
    }
  },
  {
    path: '/app/:app/',
    name: 'appcontainer',
    component: AppContainer,
    meta: {
      title: 'App Settings - ' + APP_TITLE,
      metaTags: [{
        name: 'description',
        content: 'Settings for the app on the ' + APP_TITLE
      },
      {
        property: 'og:description',
        content: 'Settings for the app on the ' + APP_TITLE
      }
      ]
    }
  },
  {
    path: '/app/:app/:category/:langCode',
    name: 'editorcontainer',
    component: EditorContainer,
    meta: {
      title: 'Edit Document - ' + APP_TITLE,
      metaTags: [{
        name: 'description',
        content: 'Edit Document for the app on the ' + APP_TITLE
      },
      {
        property: 'og:description',
        content: 'Edit Document for the app on the ' + APP_TITLE
      }
      ]
    }
  }
  ]
})

router.afterEach((to, from) => {
  document.title = to.meta.title || APP_TITLE
})

export default router
